export type StatusCtx = {
  data: any;
  isMonitoring: boolean;
  isAgency: boolean;
  isCgs: boolean;
  canReviewApp: boolean;
  isInAgencyScope: boolean;
  isHead: boolean;
};

export type StatusRule = {
  value: string;
  label: string;
  when: (ctx: StatusCtx) => boolean;
  disabled: (ctx: StatusCtx) => boolean;
};

const isFulfilled          = (ctx: StatusCtx) => !!ctx.data?.is_fullfilled_used_amount;
const isNotRejected        = (ctx: StatusCtx) => ctx.data?.monitoring_approval_status !== "REJECTED";
const isPendingAgency      = (ctx: StatusCtx) => ctx.data?.monitoring_approval_status === "REMONITORING_PENDING_AGENCY";
const canActAsAgency       = (ctx: StatusCtx) => ctx.isAgency && ctx.canReviewApp && (ctx.isInAgencyScope || isPendingAgency(ctx));
const isAgencyHead         = (ctx: StatusCtx) => ctx.isAgency && ctx.isHead && ctx.canReviewApp;

export const statusRules: StatusRule[] = [
  {
    value: "APPROVED",
    label: "დადასტურება - გაიარა მონიტორინგი არ ექვემდებარება პროგრამიდან ჩახსნას",
    when:     (ctx) => (ctx.isMonitoring && ctx.isCgs && isNotRejected(ctx) && isFulfilled(ctx)) || (!isPendingAgency(ctx) && ((ctx.isAgency && ctx.canReviewApp && isNotRejected(ctx) && isFulfilled(ctx)) || (isAgencyHead(ctx) && isNotRejected(ctx)))),
    disabled: (ctx) => ctx.isAgency && !canActAsAgency(ctx),
  },
  {
    value: "REMONITORING",
    label: "დადასტურება - გაიარა მონიტორინგი ექვემდებარება ხელახალ მონიტორინგს",
    when:     (ctx) => (ctx.isMonitoring && ctx.isCgs && isNotRejected(ctx) && !isFulfilled(ctx) && (!!ctx.data?.is_deadline_approve || isPendingAgency(ctx))) || (ctx.isAgency && isNotRejected(ctx) && !isFulfilled(ctx) && (!!ctx.data?.is_deadline_approve || isPendingAgency(ctx))),
    disabled: (ctx) => ctx.isAgency && !canActAsAgency(ctx),
  },
  {
    value: "REMONITORING_PENDING_AGENCY",
    label: "დადასტურება - გაიარა მონიტორინგი ექვემდებარება ხელახალ მონიტორინგს (სააგენტოს დასტური)",
    when:     (ctx) => !isPendingAgency(ctx) && ((ctx.isMonitoring && ctx.isCgs && isNotRejected(ctx) && !isFulfilled(ctx) && !ctx.data?.is_deadline_approve) || (ctx.isAgency && isNotRejected(ctx) && !isFulfilled(ctx) && !ctx.data?.is_deadline_approve)),
    disabled: (ctx) => ctx.isAgency && !canActAsAgency(ctx),
  },
  {
    value: "REMOVAL",
    label: "დადასტურება - გაიარა მონიტორინგი ექვემდებარება პროგრამიდან ჩახსნას",
    when:     (ctx) => ((ctx.isMonitoring && ctx.isCgs) || ctx.isAgency) && isNotRejected(ctx),
    disabled: (ctx) => ctx.isAgency && !canActAsAgency(ctx),
  },
];
